module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/icon_more-8bd337fa9817b7560bea23678bd6f371.svg";